<div class="w-full h-full flex flex-col justify-between items-end px-4 overflow-hidden">
  <div class="h-16 flex items-center -mr-1.5">
    <button mat-icon-button color="primary" type="button" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-2">close</mat-icon>
    </button>
  </div>
  <div class="h-[calc(100%_-_80px)] w-full rounded-xl overflow-hidden">
    <google-map height="100%" width="100%" [options]="options" [center]="location">
      <map-marker #markerElem="mapMarker" [options]="markerOptions" [position]="location" />
    </google-map>
  </div>
  <div class="h-16 flex items-center">
    <xemex-outlined-button type="button" (click)="dialogRef.close()">Close</xemex-outlined-button>
  </div>
</div>
